module.exports = __webpack_public_path__ + "static/media/firma-juan-carlos@2x.dafba519.jpg";